module.exports = __webpack_public_path__ + "static/media/baseline_create_black_18dp.0a5169e1.svg";